import { TableRowSkeleton } from "../Dashboard/Quotes";
import { SearchIcon } from "../Icons";
import { useGetCustomersWithQuotesQuery } from "../../store/apiSlices/adminApi";
import { useNavigate } from "react-router-dom";

export default function OngoingOrders() {
  const navigate = useNavigate();

  const { data: userWithRFQs, isLoading } = useGetCustomersWithQuotesQuery({
    status: "confirmed",
  });

  const hasData = userWithRFQs && userWithRFQs.length > 0;

  return (
    <section className="card h-[450px] flex flex-col">
      {/* Header */}
      <div className="py-2 flex items-center justify-between">
        <h2 className="text-[#030303] font-semibold text-xl">Ongoing Orders</h2>

        <div className="relative">
          <SearchIcon className="size-6 absolute top-[8px] left-2 text-gray-500" />

          <input
            type="search"
            placeholder="Search"
            className="w-full px-[10px] py-2 pl-10 border border-gray-300 rounded-lg bg-[#fcfcfd] text-[0.9rem] text-gray-900 transition duration-300 focus:border-blue-500 focus:ring focus:ring-blue-200 outline-none"
          />
        </div>
      </div>

      {/* Table Container */}
      <div className="mt-4 flex-1 overflow-hidden rounded-lg border border-gray-200">
        <div className="h-full overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="sticky top-0 bg-gray-50 z-10">
              <tr className="text-left">
                <th className="p-4 font-semibold text-gray-700">
                  Customer Name
                </th>
                <th className="p-4 font-semibold text-gray-700">Ongoing</th>
                <th className="p-4 font-semibold text-gray-700">Task</th>
              </tr>
            </thead>

            <tbody>
              {/* Loading */}
              {isLoading &&
                [1, 2, 3, 4].map((el) => <TableRowSkeleton key={el} />)}

              {/* Data */}
              {!isLoading &&
                hasData &&
                userWithRFQs.map((el) => (
                  <tr
                    key={el.uid}
                    className="hover:bg-gray-50 transition-colors cursor-pointer"
                    onClick={() =>
                      navigate(`/admin/customer-profiles/${el.uid}`)
                    }
                  >
                    <td className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500 to-blue-500" />

                        <div className="min-w-0">
                          <p className="truncate text-sm font-medium text-gray-900">
                            {el.company_name}
                          </p>
                          <p className="truncate text-xs text-gray-500">
                            {el.work_email}
                          </p>
                        </div>
                      </div>
                    </td>

                    <td className="p-4 text-gray-600">{el.total_count || 0}</td>
                    <td className="p-4 text-gray-600">{0}</td>
                  </tr>
                ))}

              {/* Empty */}
              {!isLoading && !hasData && (
                <tr>
                  <td colSpan={3} className="text-center py-20 text-gray-500">
                    No RFQs found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
